<mat-card>
<h3>Test Series Mapping</h3>

<mat-card-content>

<form [formGroup]="indivCompSubMapping" (ngSubmit)="onSubmit()">

<!-- 	<mat-form-field>
		  <mat-label>Individual Type</mat-label>
		  <mat-select placeholder="Test Type List" required>
		    <mat-option></mat-option>
		    <mat-option [value]="compSub.id" *ngFor="let compSub of competitionType">{{ compSub.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Test Type</mat-error>
	</mat-form-field>
		
		 -->
	<fieldset>
	  <legend>
		  <h4>Available Test Type Vs Subject List</h4>
	  </legend> 
	
	<table>
		<tr>
			<th>Competition Type</th>
			<th class="divider-vertical-header-full-height">Subject Type</th>
			<th class="divider-vertical-header-full-height">No of Questions</th>
			<th class="divider-vertical-header-full-height">Test Timeout</th>
			<th class="divider-vertical-header-full-height">Correct Ans Mark</th>
			<th class="divider-vertical-header-full-height">Wrong Ans Mark</th>
			<th class="divider-vertical-header-full-height">Skip Ans Mark</th>
			<th class="divider-vertical-header-full-height">Add</th>
		</tr>
		
		<ng-container formArrayName="compSubList" *ngFor="let csmArr of compSubArray.controls; let i = index">
		<tr [formGroupName]="i">
		
			<mat-form-field [style.display]="'none'">
		       <input matInput placeholder="Id" formControlName="id">
		     </mat-form-field>
			<td>
				<mat-form-field [style.display]="'none'" class="full-width-input">
			       <input matInput placeholder="Competition Type" formControlName="competitionType">
			     </mat-form-field>
			     <mat-form-field class="full-width-input">
			       <input matInput placeholder="Competition Type" formControlName="competitionTypeDesc">
			     </mat-form-field>
			</td>
			<td>
				<mat-form-field [style.display]="'none'" class="full-width-input">
			       <input matInput placeholder="Subject Type" formControlName="subjectType">
			     </mat-form-field>
			     <mat-form-field class="full-width-input">
			       <input matInput placeholder="Subject Type" formControlName="subjectTypeDesc">
			     </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Questions" formControlName="noOfQuestionsToAttempt"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Min 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Time Out" formControlName="testTimeoutMinute"
						required> <mat-error> Please provide a valid
					Test Timeout </mat-error> <mat-hint>Min 1, Max 999</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Questions" formControlName="marksCorrectAnswer"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Number and between 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Questions" formControlName="marksWrongAnswer"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Number and between 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Questions" formControlName="marksSkipAnswer"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Number and between 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td><button mat-raised-button color="primary" (click)="addIndivCompSubMapping(i)">
					<mat-icon>add_forever</mat-icon>
				</button></td>
		</tr>
		</ng-container>
		
		
		<tr colspan="8">
		  <td><div *ngIf="competitionSubjectMapping === undefined || competitionSubjectMapping.length === 0">No records found</div></td>
		</tr>
	</table>
	</fieldset>
	<!-- <mat-selection-list  placeholder="Test type Vs Subject List" required  #ctVsStList>
	  <mat-list-option [value]="csm.id" *ngFor="let csm of competitionSubjectMapping ">
	    {{csm.competitionTypeDesc}} -> {{csm.subjectTypeDesc}} 
	  </mat-list-option>
	  <mat-error> Please select at least one Role</mat-error>
	</mat-selection-list> -->


<fieldset>
	  <legend>
		  <h4>Assigned Test Type Vs Subject List</h4>
	  </legend> 
	
	<div>
	<table>
		<tr>
			<th>Competition Type</th>
			<th class="divider-vertical-header-full-height">Subject Type</th>
			<th class="divider-vertical-header-full-height">No of Questions</th>
			<th class="divider-vertical-header-full-height">Test Time Out</th>
			<th class="divider-vertical-header-full-height">Correct Ans Mark</th>
			<th class="divider-vertical-header-full-height">Wrong Ans Mark</th>
			<th class="divider-vertical-header-full-height">Skip Ans Mark</th>
			<th class="divider-vertical-header-full-height">Edit</th>
			<th class="divider-vertical-header-full-height">Delete</th>
		</tr>
		<!-- <tr *ngFor="let itemIcsm of indivCompetitionSubjectMapping">
			<td>{{itemIcsm.competitionTypeDesc}}</td>
			<td>{{itemIcsm.subjectTypeDesc}} </td>
			<td><button mat-button (click)="deleteIndivCompSubMapping(itemIcsm.id)">
					<mat-icon>delete_forever</mat-icon>
				</button></td>
			<td>&nbsp;</td>
		</tr> -->

		<ng-container formArrayName="indivCompSubList" *ngFor="let icsmArr of indivCompSubArray.controls; let i1 = index">
		<tr [formGroupName]="i1">
		
			<mat-form-field [style.display]="'none'">
		       <input matInput placeholder="Id" formControlName="id">
		     </mat-form-field>
			<td>
				<mat-form-field [style.display]="'none'" class="full-width-input">
			       <input matInput placeholder="Competition Type" formControlName="competitionType">
			     </mat-form-field>
			     <mat-form-field class="full-width-input">
			       <input matInput placeholder="Competition Type" formControlName="competitionTypeDesc">
			     </mat-form-field>
			</td>
			<td>
				<mat-form-field [style.display]="'none'" class="full-width-input">
			       <input matInput placeholder="Subject Type" formControlName="subjectType">
			     </mat-form-field>
			     <mat-form-field class="full-width-input">
			       <input matInput placeholder="Subject Type" formControlName="subjectTypeDesc">
			     </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Questions" formControlName="noOfQuestionsToAttempt"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Number and between 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Timeout In Minute" formControlName="testTimeoutMinute"
						required> <mat-error> Please provide a valid
					Timeout for Test</mat-error> <mat-hint>Number and between 1, Max 999</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Correct Ans Mark" formControlName="marksCorrectAnswer"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Number and between 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Wrong Ans Mark" formControlName="marksWrongAnswer"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Number and between 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td>
				<mat-form-field class="full-width-input"> <input
						matInput placeholder="Skip Mark" formControlName="marksSkipAnswer"
						required> <mat-error> Please provide a valid
					Number of Questions</mat-error> <mat-hint>Number and between 0, Max 50</mat-hint> </mat-form-field>
			</td>
			<td><button mat-raised-button color="primary" (click)="editIndivCompSubMapping(i1)">
					<mat-icon>edit_forever</mat-icon>
				</button>
			</td>
			<td>	<button mat-button (click)="deleteIndivCompSubMapping(i1)">
					<mat-icon>delete_forever</mat-icon>
				</button>
			</td>
		</tr>
		</ng-container>
		
		<tr colspan="8">
		  <td><div *ngIf="indivCompetitionSubjectMapping === undefined || indivCompetitionSubjectMapping.length === 0">No records found</div></td>
		</tr>
	</table>
	</div>
	</fieldset>
	<!-- <mat-selection-list  placeholder="Assigned Test type Vs Subject List" required  #actVsStList>
	  <mat-list-option [value]="icsm.id" *ngFor="let icsm of indivCompetitionSubjectMapping ">
	    {{icsm.competitionTypeDesc}} -> {{icsm.subjectTypeDesc}} 
	    <button mat-button (click)="deleteIndivCompSubMapping(icsm.id)">
			<mat-icon>delete_forever</mat-icon>
		</button>
	  </mat-list-option>
	  
	</mat-selection-list> -->
	</form>

<!-- <button mat-raised-button color="primary"
	 (click)="onSubmit()">Save</button>
<button mat-raised-button color="primary"
	(click)="resetIndivCompSubMappingList()">Reset</button>
 -->
</mat-card-content> </mat-card>